import environment from '@environment';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { SiteConfigStore } from 'core/stores/site-config.store';

export class LiveChatService {
  private static LiveChatApiBuilder = new EndpointHelper(environment.LIVE_CHAT_IFRAME);

  static IFrameContentURL(
    displayName: string,
    firstName: string,
    lastName: string,
    chatProduct: string,
    smartCardNumber: string,
    country: string,
    customerNumber: string,
    lang: string
  ) {
    return this.LiveChatApiBuilder.createUrl('LiveChats/SetUpLiveChat')
      .addQueryParam('DisplayName', displayName)
      .addQueryParam('FirstName', firstName)
      .addQueryParam('LastName', lastName)
      .addQueryParam('ChatProduct', chatProduct)
      .addQueryParam('SmartcardNumber', smartCardNumber)
      .addQueryParam('CustomerNumber', customerNumber)
      .addQueryParam('Country', country)
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .addQueryParam('Culture', lang)
      .build();
  }
}